export default __webpack_public_path__ + "static/1-3c07bc21b32667f2015b79cc5be3236c.jpeg";